import { getArtigosRecentes } from "@/lib/blog.functions";
import { createFileRoute } from "@tanstack/react-router";

import { JsonLd } from "@/components/seo/JsonLd";
import { Longevidade, faq } from "@/components/itv/pages/Longevidade";
import { carregarPaginaSimples } from "@/lib/pagina-simples";
import { getSiteData } from "@/lib/site-data.functions";
import {
  breadcrumbSchema,
  faqSchema,
  medicalWebPageSchema,
  physicianSchema,
  type Trilha,
} from "@/lib/schema";

const PATH = "/tratamentos/longevidade/";
const TITLE = "Medicina da Longevidade e Prevenção | Dr. Thiago Viana";
const DESCRIPTION =
  "Plano médico preventivo com foco em vitalidade, preservação da massa muscular, saúde metabólica, qualidade do sono e acompanhamento contínuo em Bauru.";

export const Route = createFileRoute("/tratamentos/longevidade")({
  loader: async () => {
    const [site, head, artigos] = await Promise.all([getSiteData(), carregarPaginaSimples(PATH, TITLE, DESCRIPTION), getArtigosRecentes()]);
    return { site, artigos, ...head };
  },
  staticData: { declaraPhysician: true },
  head: ({ loaderData }) => ({
    meta: loaderData?.meta ?? [],
    links: loaderData?.links ?? [],
  }),
  component: Page,
});

function Page() {
  const { site, artigos } = Route.useLoaderData();
  const trilha: Trilha[] = [
    { nome: "Home", path: "/" },
    { nome: "Tratamentos", path: "/tratamentos/" },
    { nome: "Longevidade", path: PATH },
  ];

  return (
    <>
      <Longevidade artigos={artigos} />
      <JsonLd data={medicalWebPageSchema({ path: PATH, title: TITLE, description: DESCRIPTION })} />
      <JsonLd data={breadcrumbSchema(trilha)} />
      <JsonLd data={faqSchema(faq)} />
      <JsonLd data={physicianSchema(site.doctor, "completa")} />
    </>
  );
}
